"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function WysiwygFields(_ref) {
  var isEnglish = _ref.isEnglish,
    isSpanish = _ref.isSpanish,
    renderAdvancedOptions = _ref.renderAdvancedOptions,
    subFormikBag = _ref.subFormikBag;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-lg-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "headingEn"
  }, function (fieldProps) {
    return isEnglish ? /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, _extends({
      label: "Heading (En)"
    }, fieldProps), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
      content: fieldProps.field.value || '',
      onBlur: fieldProps.field.onBlur,
      onChange: function onChange(value) {
        fieldProps.form.setErrors({});
        fieldProps.form.setFieldValue(fieldProps.field.name, value);
      },
      type: "input"
    })) : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdInput, _extends({}, fieldProps, {
      disabled: true,
      label: "Heading (En)"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-lg-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "headingEs"
  }, function (fieldProps) {
    return isSpanish ? /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, _extends({
      label: "Heading (Es)"
    }, fieldProps), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
      content: fieldProps.field.value || '',
      onBlur: fieldProps.field.onBlur,
      onChange: function onChange(value) {
        fieldProps.form.setErrors({});
        fieldProps.form.setFieldValue(fieldProps.field.name, value);
      },
      type: "input"
    })) : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdInput, _extends({}, fieldProps, {
      disabled: true,
      label: "Heading (Es)"
    }));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-lg-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "contentEn"
  }, function (fieldProps) {
    return isEnglish ? /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, _extends({
      label: "Content (En)"
    }, fieldProps), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
      content: fieldProps.field.value,
      onBlur: fieldProps.field.onBlur,
      onChange: function onChange(value) {
        fieldProps.form.setErrors({});
        fieldProps.form.setFieldValue(fieldProps.field.name, value);
      },
      type: "textarea"
    })) : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdTextarea, _extends({}, fieldProps, {
      label: "Content (En)",
      disabled: true,
      rows: "12"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-lg-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "contentEs"
  }, function (fieldProps) {
    return isSpanish ? /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, _extends({
      label: "Content (Es)"
    }, fieldProps), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
      content: fieldProps.field.value,
      onBlur: fieldProps.field.onBlur,
      onChange: function onChange(value) {
        fieldProps.form.setErrors({});
        fieldProps.form.setFieldValue(fieldProps.field.name, value);
      },
      type: "textarea"
    })) : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdTextarea, _extends({}, fieldProps, {
      label: "Content (Es)",
      disabled: true,
      rows: "12"
    }));
  }))), renderAdvancedOptions(subFormikBag));
}
var _default = exports["default"] = WysiwygFields;